import axios from "axios";

export default axios.create({
  // eslint-disable-next-line no-undef
  baseURL: __BASEURL__
});
